import * as Styled from './_styled/err-message-styled'

export function ErrorMessage(): JSX.Element {
    return (
        <Styled.ErrorParagraph>
            You are not authorised to make this terminal connection.
        </Styled.ErrorParagraph>
    )
}
